import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon, MinusIcon } from 'lucide-react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const checkboxVariants = cva(
  'bg-blend-overlay gradient-to-b from-white-30 to-white-0 border-input hover:cursor-pointer rounded-[0.375rem] border outline-none disabled:cursor-not-allowed',
  {
    variants: {
      size: {
        sm: 'size-5 [&_svg]:size-4',
        md: 'size-6 [&_svg]:size-5',
      },
      color: {
        base: 'bg-base-surface-5 border-base-surface-20 hover:border-base-surface-40 active:bg-base-surface-20 active:border-base-surface-40 disabled:bg-disabled-surface-light  disabled:border-disabled-surface-dark border-[1.5px] data-[state=checked]:bg-base-main hover:data-[state=checked]:bg-base-main-light  active:data-[state=checked]:bg-base-main-light data-[state=checked]:border-0 text-base-main-100 data-[state=checked]:disabled:bg-disabled-surface  data-[state=checked]:disabled:text-disabled-surface-100',
        neutral:
          'bg-neutral-surface-5 border-neutral-surface-20 hover:border-neutral-surface-40 active:bg-neutral-surface-20 active:border-neutral-surface-40 disabled:bg-disabled-surface-light  disabled:border-disabled-surface-dark border-[1.5px] data-[state=checked]:bg-neutral-main hover:data-[state=checked]:bg-neutral-main-light  active:data-[state=checked]:bg-neutral-main-light data-[state=checked]:border-0 text-neutral-main-100 data-[state=checked]:disabled:bg-disabled-surface  data-[state=checked]:disabled:text-disabled-surface-100',
      },
    },
    defaultVariants: {
      size: 'md',
      color: 'base',
    },
  },
)

type CheckboxVariants = VariantProps<typeof checkboxVariants>

interface CheckboxProps
  extends Omit<
      React.ComponentProps<typeof CheckboxPrimitive.Root>,
      keyof CheckboxVariants
    >,
    CheckboxVariants {
  indeterminate?: boolean
}

export function Checkbox({
  className,
  size,
  color,
  indeterminate,
  ...props
}: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(checkboxVariants({ size, color, className }))}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='flex  items-center justify-center text-current transition-none'
      >
        {indeterminate ? (
          <MinusIcon strokeWidth={4} />
        ) : (
          <CheckIcon strokeWidth={4} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
